import { Stack,Dialog,Button,Grid,TextField,Box,DialogActions,DialogTitle,DialogContent,DialogContentText,Typography,Select,Fab,MenuItem,FormControl,Avatar,AvatarGroup,Alert,SelectChangeEvent  } from "@mui/material";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { serviceDescriptionCards } from "../assets/colors";
import Photo from '../assets/avatar-r.png';
import Svg1 from '../assets/boost-icon.svg';
import Svg2 from '../assets/bounce-rate-icon.svg';
import Svg3 from '../assets/increase-conversion-icon.svg';
import AddIcon from '@mui/icons-material/Add';
import Slider from 'react-slick';
import Recommend from '../assets/image_36.png'    
import chatImg from '../assets/image_34.png'
import { useForm } from "react-hook-form";
import FetchProjects from '../hooks/fetchProjects';
import FetchTeams from '../hooks/fetchTeams';
import BookmarkService from '../hooks/bookmarkService';
import FetchChat from '../hooks/fetchChat';
import useMediaQuery from '@mui/material/useMediaQuery';
import 'typeface-inter';
import $ from 'jquery';

const CustomPrevArrow = () => null;
const CustomNextArrow = () => null;
const mystyle = {
  display: "flex",
  alignItems: "center",
};

const ulStyles = {
  paddingLeft: "20px",
};

const team = {
  display: "flex",
  gap: "20px",
  alignItems: "center",
};

interface Project {
  id: string | number | readonly string[] | undefined;
  project_id: string;
  project_name: string;
}

interface Team {
  email: string;
}

interface SendProjectInput {
  project_name: string;
  emails: string[]; 
}

interface LeftPanelProps {
  onSelectionChange: (value: string) => void;
}

export const LeftPanel: React.FC<LeftPanelProps> = ({ onSelectionChange }) => {
  const handleItemClick = (value: string) => {
    onSelectionChange(value);
  };

  const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: true, 
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: <CustomPrevArrow />,
      nextArrow: <CustomNextArrow />
  };

  const [teamopen, teamOpen] = React.useState(false);
  const teamClickOpen = () => {
    teamOpen(true);
  };
  const teamClose = () => {
    teamOpen(false);
  };

  const customFabStyle = { 
    width: "30px",
    height: "30px",
    minHeight: "30px",
    backgroundColor: '#cceeff'
  };

  const customIconStyle = {
    color: '#000'
  };

  const {
    register: registerTeam,
    handleSubmit: handleSubmitTeam,
    reset: resetTeamForm,
    formState: { errors: errorsTeam },
  } = useForm<SendProjectInput>();

  const [teamEmails, setTeamEmails] = useState(['']); 
  const [project, setProject] = useState("");
  const [errorMessageTeam, setErrorMessageTeam] = useState(''); 
  const [successMessageTeam, setSuccessMessageTeam] = useState(''); 

  const userDataString = localStorage.getItem('user');
  const userData = userDataString ? JSON.parse(userDataString) : null;
  const userId = userData ? userData.user.user_id : null;

  // fetch projects
  const userprojects  = FetchProjects(userId);
    useEffect(() => {
  }, [userprojects]);
   

  const [selectedProjectId, setSelectedProjectId] = useState<string | ''>('');

  const handleProjectChange = (event: SelectChangeEvent<{ value: unknown }>, child: React.ReactNode) => {
    const value = event.target.value as string | '';
    setSelectedProjectId(value);
  };

  const handleAddEmail = () => {
    setTeamEmails([...teamEmails, '']);
  };
  
  const handleRemoveEmail = (indexToRemove: number) => {
    const updatedEmails = teamEmails.filter((email, index) => index !== indexToRemove);
    setTeamEmails(updatedEmails);
  };

    //const user_id = encodeURIComponent(userId);
    //fetch teams
  const [teams, setTeams] = useState<Team[]>([]);
  useEffect(() => {
    if (selectedProjectId) {
      const fetchData = async () => {
        const apiUrl = 'http://34.94.96.59:5050/infindbot/get_users';
        try {
          const response = await axios.get(apiUrl, {
            params: {
              project_name: selectedProjectId,
            },
            headers: {
              'Content-Type': 'application/json',
            },
          });
            setTeams(response.data.content);
        } catch (error:any) {
          if (axios.isAxiosError(error)) {
            if (error.response) {
              console.error('Server responded with:', error.response.status);
              console.error('Error data:', error.response.data);
            } else if (error.request) {
              console.error('No response received from server');
            } else {
              console.error('Error during request setup:', error.message);
            }
          } else {
            console.error('Non-Axios error:', error.message);
          }
        }
      };
        fetchData();
    }else{
      setTeams([]);
    }
  }, [selectedProjectId]);

  interface Chat {
    [x: string]: any;
    user_id: string;
  }
  // const [userchats, setUserChats] = useState<Chat[]>([]);
  // useEffect(() => {
  //   const fetchUserChats = async () => {
  //     try {
  //       const data = FetchChat(userId);
  //       console.log("sss",data)
  //       setUserChats(data);
  //     } catch (error) {
  //       console.error('Error fetching user chats:', error);
  //     }
  //   };
  //   if (userId) {
  //     fetchUserChats();
  //   }
  // }, [userId]);

  const userchats  = FetchChat(userId);
    useEffect(() => {
  }, [userchats]);


  const submitTeamData = async (data: any) => {
    const project_name = data.project_name;
    const teamEmails = data.emails; 
    const input: SendProjectInput = { project_name: project_name, emails: teamEmails };
    const apirequest = 'http://34.94.96.59:5050/infindbot/project';
    try {
      const response = await fetch(apirequest, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(input),
      });
    
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const responseData = await response.json();
      console.log(responseData);
      if (responseData.error) {
        setErrorMessageTeam(responseData.error);
        setTimeout(() => {
          setErrorMessageTeam('');
        }, 3000);
      } else {
        setSuccessMessageTeam("Request successful");
        resetTeamForm();
        setTimeout(() => {
          setSuccessMessageTeam('');
          teamOpen(false);
          window.location.reload();
        }, 3000);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  // fetch bookmarks
  const userbookmarks = BookmarkService(userId);
    useEffect(() => {
  }, [userbookmarks]);

  const isMobile = useMediaQuery('(min-width:768px)');

    return (
      <Stack
        direction="column"
        spacing="20px"
        paddingBottom={"20px"}
        paddingLeft={"20px"}
        paddingRight={"20px"}
        // padding={"20px"}
      >
      <Stack
          style={{
            background: serviceDescriptionCards,
            padding: "20px",
          }}
          borderRadius='20px'
          justifyContent="center"
          alignItems={"flex-start"}
          direction={"column"}
        >
        
      <div style={mystyle}>
      <Typography color={"black"} fontSize={"16px"} fontWeight={"700"} fontFamily={"inter"}> 
         Project:
        </Typography> 
        <FormControl  style={{
          minWidth: isMobile ? '230px' : '210px',
          margin: isMobile ? '8px' : '8px',
        }}>
       
       {userprojects.length > 0 ? (
       <Select
       SelectDisplayProps={{ style: { paddingTop: 8, paddingBottom: 8 } }}
      
         displayEmpty
         inputProps={{ 'aria-label': 'Without label' }}
         onChange={handleProjectChange}
       >
          {userprojects.map((project: Project, index: number) => (
            <MenuItem key={index} value={project.project_name}>{project.project_name}</MenuItem>
          ))}
        </Select>
      ) : (
        <Select
        SelectDisplayProps={{ style: { paddingTop: 8, paddingBottom: 8 } }}
       
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
        >
       
          <MenuItem value="">
            <em>No projects found.</em>
          </MenuItem>
        </Select>
      )}

    </FormControl>
      <Fab size="small" style={customFabStyle} color="primary" aria-label="add" onClick={teamClickOpen}>
        <AddIcon  style={customIconStyle} />
      </Fab>
      </div>
      <div style={team}>
      <Typography color={"black"} fontSize={"16px"} fontWeight={"700"} fontFamily={"inter"}> 
         Team:
        </Typography> 
        
      {teams.length > 0  && (
        <AvatarGroup total={teams.length}>
          {teams.map((team: Team, index: number) => (
            <><p>{team.email}</p>
            <Avatar key={index} alt="Remy Sharp" src={Photo} style={{ width: "30px", height: "30px" }} /></>
          ))}
        </AvatarGroup>
      )}

{/* <Fab size="small" style={customFabStyle} color="primary" aria-label="add" onClick={teamClickOpen}>
        <AddIcon  style={customIconStyle} />
      </Fab> */}
      <Dialog open={teamopen} onClose={teamClose}>
        <DialogTitle>Add Project</DialogTitle>
        <DialogContent>
          {successMessageTeam && (
            <Alert severity="success">{successMessageTeam}</Alert>
          )}
          {errorMessageTeam && (
            <Alert severity="error">{errorMessageTeam}</Alert>
          )}
          <DialogContentText>
            Add your Team to display in list.
          </DialogContentText>
          <form autoComplete="off" onSubmit={handleSubmitTeam(submitTeamData)}>
            <Box component="form" noValidate sx={{ mt: 3 }}>
              <Grid container spacing={2}>
              <Grid item xs={12}>
                  <TextField
                    variant="standard"
                    fullWidth
                    id="filled-textarea"
                    label="Project Name"
                    multiline
                    {...registerTeam("project_name", {
                      required: "Project Name is required!",
                    })}
                    onChange={(e) => {
                      setProject(e.target.value);
                    }}
                    error={!!errorsTeam.project_name}
                    helperText={(errorsTeam.project_name?.message as any) }
                  />
                </Grid>

                <Grid item xs={12}>
                
                {teamEmails.map((email, index) => (
                  <div key={index}>
                <TextField
                   required
                   autoFocus={index === 0}
                   id={`email-${index}`}
                   label={`Email Address ${index + 1}`}
                   type="email"
                   fullWidth
                   variant="standard"
                   multiline
                   value={email}
                   {...registerTeam(`emails[${index}]` as keyof SendProjectInput, {
                    required: "Email is required!",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Invalid email address!",
                    },
                  })}
                  onChange={(e) => {
                    const updatedEmails = [...teamEmails];
                    updatedEmails[index] = e.target.value;
                    setTeamEmails(updatedEmails);
                  }}
                  error={!!(errorsTeam?.emails && typeof index === 'number' && errorsTeam.emails[index])}
                  helperText={(errorsTeam?.emails && typeof index === 'number' && errorsTeam.emails[index]?.message) || ''}
                 />
                 {teamEmails.length > 1 && (
                      <Button onClick={() => handleRemoveEmail(index)}>Remove Email</Button>
                    )}
                  </div>
                ))}
                <Button onClick={handleAddEmail}>Add Email</Button>
                </Grid>
              </Grid>
            </Box>
            <DialogActions>
          <Button onClick={teamClose}>Cancel</Button>
          <Button type="submit">Submit</Button>
        </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      </div>
      </Stack>
      <Stack
        style={{
          background: serviceDescriptionCards,
          padding: "20px",
        }}
        borderRadius='20px'
        justifyContent="center"
        alignItems={"flex-start"}
      >
        
        <Typography color={"black"} fontSize={"16px"} fontWeight={"700"} fontFamily={"inter"}> 
        Saved Patents:
        </Typography>  
        <Stack  style={{
              width: "100%",
              overflowY: "scroll",
              maxHeight: "100px"
        }} >
       <ul className="recommendations" style={ulStyles}>
        {userbookmarks.length === 0 ? (
          <li style={{ listStyleType: 'none' }}> <Typography color={"black"} className="NoDataRec" >Novartis - Kymriah</Typography> </li>
        ) : (
          userbookmarks.map((item, index) => ( 
          <li key={index} style={{ listStyleType: 'none' }}><div style={{display:"flex", alignItems:"baseline", gap:"9px", }} ><img src={Recommend} style={{position:"relative", top:"3px"}} /><p style={{fontSize:"14px", marginBottom:"2px"}}>{item.title}_{item.part_number}</p></div></li>
        ))
       )}
     </ul>  
        </Stack>
      </Stack>
      <Stack
        style={{
          background: serviceDescriptionCards,
          padding: "20px",
        }}
        borderRadius='20px'
        justifyContent="center"
        alignItems={"flex-start"}
      >
       
       <Typography color={"black"} fontSize={"16px"} fontWeight={"700"} fontFamily={"inter"}> 
         Search History:
        </Typography>  
        <Stack style={{
              width: "100%",
              overflowY: "scroll",
              maxHeight: "100px"
        }}>
        <ul className="allchats" style={ulStyles}>
          {userchats.length === 0 ? (
            <li style={{ listStyleType: 'none' }}>
              <Typography color={"black"} className="NoData">
                Patented Drugs Targeting CD30
              </Typography>
            </li>
          ) : (
            userchats.map((chat: Chat, index: number) => (
              <React.Fragment key={index}>
                {Object.keys(chat).map((dynamicKey, dynamicIndex) => (
                  <li key={dynamicIndex}
                  onClick={() => handleItemClick(dynamicKey)}
                  style={{ listStyleType: 'none' }}
                  >
                    {chat[dynamicKey]?.conversation_history?.[0] ? (
                      <div style={{ display: "flex", alignItems: "baseline", gap: "9px" }}>
                        <img src={chatImg} style={{ position: "relative", top: "3px" }} />
                        <p style={{ fontSize: "14px", marginBottom: "2px" }}>{chat[dynamicKey].conversation_history[0].content}</p>
                      </div>
                    ) : (
                      <div>No conversation history available for {dynamicKey}</div>
                    )}
                  </li>
                ))}
              </React.Fragment>
            ))
            
            
            // userchats.map((item, outerIndex) => (
            //   <React.Fragment key={outerIndex}>
                
            //     {item && (
            //       <>
            //       <li
            //          // onClick={() => handleItemClick(item[0].session_id)}
            //           style={{ listStyleType: 'none' }}
            //         >
            //           <div style={{ display: "flex", alignItems: "baseline", gap: "9px" }}>
            //             <img src={chatImg} style={{ position: "relative", top: "3px" }} />
            //             <p style={{ fontSize: "14px", marginBottom: "2px" }}></p>
            //           </div>
            //         </li>
            //       </>
            //     )}
            //   </React.Fragment>
            // ))
          )}
        </ul>
      </Stack>
    </Stack>
    <Stack style={{
        background: serviceDescriptionCards,
        padding: "20px",
      }}
      borderRadius='20px'
    >
      <Typography color={"black"} fontSize={"16px"} fontWeight={"700"} fontFamily={"inter"}> 
        Tips:
      </Typography>
    <div>
      <Slider {...settings}>
      <div>
        <div
          style={{
            justifyContent: "center",
            margin: "10px auto",
            display: "flex",
          }}
        >
          <img
            src={Svg1}
            alt="increase-conversion-icon"
            width={"30px"}
            height="30px"
          />
        </div>
        <Typography color={"black"} fontFamily={"inter"}>Click example prompts on the top of text box to get you started!</Typography>
      </div>
      <div>
      <div
        style={{
          justifyContent: "center",
          margin: "10px auto",
          display: "flex",
        }}
      >
        <img
           src={Svg2}
          alt="increase-conversion-icon"
          width={"30px"}
          height="30px"
        />
      </div>
        <Typography color={"black"} fontFamily={"inter"}>You can save relevant patents which will show up in the saved patents list!</Typography>
      </div>
      <div>
      <div
        style={{
          justifyContent: "center",
          margin: "10px auto",
          display: "flex",
        }}
      >
        <img
          src={Svg3}
          alt="increase-conversion-icon"
          width={"30px"}
          height="30px"
        />
      </div>
      <Typography color={"black"} fontFamily={"inter"}>Use post search keyword filter to narrow down search results!</Typography>
      </div>
      </Slider>
    </div>
    </Stack>
  </Stack>
  );
};